<template>
  <b-nav-item-dropdown id="dropdown-grouped" variant="link" class="dropdown-language" right>
    <template #button-content>
      <b-img :src="currentLocale.img" height="14px" width="22px" :alt="currentLocale.locale" />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item v-for="localeObj in locales" :key="localeObj.locale" @click="$i18n.locale = localeObj.locale">
      <b-img :src="localeObj.img" height="14px" width="22px" :alt="localeObj.locale" />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import { getApplicationLanguages } from '@/utils/languageHelper'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  data() {
    return {
      locales: [],
      isLoading: false,
    }
  },
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale) || this.locales[0]
    },
  },
  methods: {
    async fetchApplicationLanguages() {
      try {
        this.isLoading = true
        const languages = await getApplicationLanguages()
        
        // Transform languages to locale format with flag images
        this.locales = languages.map(lang => ({
          locale: lang.lang,
          img: this.getFlagImage(lang.lang),
          name: lang.name,
          enabled: lang.enabled
        })).filter(lang => lang.enabled !== false) // Only show enabled languages
      } catch (error) {
        console.error('Error fetching application languages:', error)
        // Fallback to default languages if API fails
        this.setDefaultLocales()
      } finally {
        this.isLoading = false
      }
    },
    
    getFlagImage(langCode) {
      // Map language codes to flag images
      const flagMap = {
        'en': require('@/assets/images/flags/en.png'),
        'th': require('@/assets/images/flags/th.png'),
        'la': require('@/assets/images/flags/la.png'),
        'ar': require('@/assets/images/flags/ar.png'),
        'ko': require('@/assets/images/flags/ko.png'),
      }
      return flagMap[langCode] || require('@/assets/images/flags/en.png')
    },
    
    setDefaultLocales() {
      // Fallback locales if API fails
      this.locales = [
        {
          locale: 'en',
          img: require('@/assets/images/flags/th.png'),
          name: 'English',
          enabled: true,
        },
        {
          locale: 'th',
          img: require('@/assets/images/flags/th.png'),
          name: 'ภาษาไทย',
          enabled: true,
        },
        {
          locale: 'la',
          img: require('@/assets/images/flags/la.png'),
          name: 'ພາສາລາວ',
          enabled: true,
        },
        {
          locale: 'ar',
          img: require('@/assets/images/flags/ar.png'),
          name: 'العربية',
          enabled: true,
        },
        {
          locale: 'ko',
          img: require('@/assets/images/flags/ko.png'),
          name: '한국어',
          enabled: true,
        },
      ]
    },
  },
  
  async mounted() {
    await this.fetchApplicationLanguages()
  },
}
</script>

<style></style>
